import React, { useEffect, useState } from 'react';
import { Callout, DelayedRender } from '@fluentui/react';
import './ArcCallout.css';
import FormattedJsonDetails from '../../Crafted/Queue/FormattedJsonDetails/FormattedJsonDetails';
import FindCaseInsensitiveProperty from '../../../Utils/General/FindCaseInsensitiveProperty';

const ArcCallout = (props) => {

    let visible = false;
    let displayData;
    const [enable, setEnable] = useState(false);
    const [mouseOver, setMouseOver] = useState(false);
    useEffect(() => {
        if(enable == false && props.trigger == true)
        {
            setEnable(true);
        }
        if (props.trigger == false && mouseOver == false) {
            setEnable(false);   
        }
    }, [props.trigger, mouseOver]);
    useEffect(() => {
        if(mouseOver == false && props.trigger == false)
        {
            setEnable(false);
        } 
    }, [mouseOver]);

    const key = FindCaseInsensitiveProperty(props.item, "TestResults");
    const testResults = props.item[key];
    if (testResults !== undefined && testResults !== null && testResults !== "[]") {
        displayData = JSON.parse(testResults);
        visible = true;
    }

    return (
        <div>
        {visible && enable && (
            <Callout className="arccallout-margin"
                gapSpace={-10}
                target={props.event}
                calloutMaxHeight={600}
                coverTarget={false}
                onMouseEnter={ (event) => { setMouseOver(true)}}
                onMouseLeave={ (event) => { setMouseOver(false)}}
            >
                <DelayedRender>
                    <FormattedJsonDetails data={displayData}></FormattedJsonDetails>
                </DelayedRender>
            </Callout>
        )}
        </div>

    );
};
  
export default ArcCallout;